import { Box } from "@mui/material"
import { useTheme } from "@mui/styles"
import { BadgeDelta, Card, Flex, Metric, ProgressBar, Text, Title } from "@tremor/react"

export default function KpiCard(props) {
    const theme = useTheme()

    const badgeDeltaType = (badgeDelta) => {
        let deltaType = 'unchanged'

        if (badgeDelta > 0) {
            deltaType = 'moderateIncrease'
        } else {
            deltaType = 'moderateDecrease'
        }

        return deltaType
    }

    const { caption, metric, valueProgress, badgeDelta, progress, target, color } = props

    return (
        <Card decoration={color && 'top'} decorationColor={color}>
            <Flex alignItems="start">
                <Box>
                    <Title color={theme.palette.mode === 'dark' ? 'white' : 'black'}>
                        {caption}
                    </Title>
                    <Metric color={theme.palette.mode === 'dark' ? 'white' : 'black'}>
                        {metric}
                    </Metric>
                </Box>

                {badgeDelta &&
                    <BadgeDelta deltaType={badgeDeltaType(badgeDelta)}>{`${badgeDelta}%`}</BadgeDelta>
                }
            </Flex>

            <Flex className="mt-4">
                <Text color={theme.palette.mode === 'dark' ? 'white' : 'black'} className="truncate">
                    {`${progress}% ${valueProgress ? '(' + valueProgress + ')' : ''}`}
                </Text>

                <Text color={theme.palette.mode === 'dark' ? 'white' : 'black'}>
                    {target}
                </Text>
            </Flex>

            <ProgressBar value={progress} className="mt-2" />
        </Card>
    )
}